<article class="form-wrapper" *ngIf="!supportButton">

  <h2 class="text">¿Olvidaste tu contraseña?</h2>

  <p class="text">Escríbenos tu correo electrónico y te enviaremos las instrucciones para reestablecerla.</p>

  <form [formGroup]="resetPasswordForm" class="sign-up-form">

    <section class="form-group">
      <input [id]="idPrefix + 'reset-password-email'"
             type="email"
             class="form-control"
             aria-describedby="Email"
             placeholder="Correo electrónico"
             maxlength="100"
             formControlName="email"
             (keyup.enter)="reset()">

      <small class="text-danger"
             [id]="idPrefix + 'reset-password-email-error'"
             *ngIf="error.email">
        {{ error.email }}
      </small>
    </section>

    <app-error-message [error]="errorObj" [idPrefix]="idPrefix + 'reset-password-'"></app-error-message>
    <app-success-message [message]="successMessage" [idPrefix]="idPrefix + 'reset-password-'"></app-success-message>

    <section class="">
      <app-button [buttonId]="idPrefix + 'reset-password'"
                  [title]="'Enviar'"
                  [isDisabled]="!resetPasswordForm.valid"
                  [customClasses]="'main full-width sign-up-button'"
                  [isLoading]="isLoading"
                  (click)="reset()"></app-button>
    </section>

  </form>

  <p class="text sm">Si olvidaste tus datos de correo, escríbenos a
    <a class="link" href="mailto:atencionalcliente@farmatodo.com" rel="noreferrer noopener" target="_blank">atencionalcliente@farmatodo.com</a></p>

  <p class="text sm">Si tu usuario es de redes sociales
    (<a class="link" href="https://www.gmail.com" rel="noreferrer noopener" target="_blank">Google</a> o
    <a class="link" href="https://www.facebook.com" rel="noreferrer noopener" target="_blank">Facebook</a>)
    recupera la contraseña en la respectiva página.</p>


  <app-overlay [isLoading]="false"></app-overlay>
</article>


<article class="form-wrapper" *ngIf="supportButton">
  <div class="header-modal">
    <div class="icon-header">
  
    </div>
    <div class="title-header">
      <h4 class="title-modal">Problemas al iniciar sesión</h4>
    </div>
  </div>
  <div class="body-modal">
    <p class="modal-text">Ingresa el correo electrónico y te enviaremos un código a tu celular para poder ingresar</p>
    <form [formGroup]="resetPasswordForm" class="sign-up-form">

      <section class="form-group">
        <input [id]="idPrefix + 'reset-password-email'"
               type="email"
               class="form-control"
               aria-describedby="Email"
               placeholder="Correo electrónico"
               maxlength="100"
               formControlName="email"
               (keyup.enter)="reset()">
  
        <small class="text-danger"
               [id]="idPrefix + 'reset-password-email-error'"
               *ngIf="error.email">
          {{ error.email }}
        </small>
      </section>
  
      <app-error-message [error]="errorObj" [idPrefix]="idPrefix + 'reset-password-'"></app-error-message>
      <app-success-message [message]="successMessage" [idPrefix]="idPrefix + 'reset-password-'"></app-success-message>
  
      <section class="">
        <app-button [buttonId]="idPrefix + 'reset-password'"
                    [title]="'Enviar'"
                    [isDisabled]="!resetPasswordForm.valid"
                    [customClasses]="'main full-width sign-up-button'"
                    [isLoading]="isLoading"
                    (click)="reset()"></app-button>
      </section>
  
    </form>
  </div>
</article>